import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';
import { AboutUsStoreLocationElementDataType } from '@/components/sections/builder/elements/body/store-location/type';
import InputSelect from '@/components/sections/builder/settings/input-select';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import PaddingSetting from '@/components/sections/builder/settings/padding-setting';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { ElementProps } from '@/components/sections/builder/types';
import { Separator } from '@/components/ui/separator';
import { useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export default function ElementSettingAddress({ element }: ElementProps) {
  const data = element.data as AboutUsStoreLocationElementDataType;

  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
    }),
    shallow
  );

  return (
    <div>
      <h1 className='mb-3 text-sm font-bold'>Section Header</h1>
      <h4 className=''>Heading Label</h4>
      <TextEditorMinimal
        value={data?.header as string}
        onChange={(val) =>
          builder.setElementData(element.id, {
            header: val,
          })
        }
        output='text'
        editorProps={{
          attributes: {
            class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
          },
        }}
        editable
      />
      <Separator className='my-4' />
      <h1 className='mb-3 text-sm font-bold'>Layout</h1>
      <div className='mb-2 grid grid-cols-2 items-center gap-2'>
        <label className='text-xs'>View location position</label>
        <InputSelect
          defaultValue={data.style}
          options={[
            { label: 'Grid', value: 'grid' },
            { label: 'Carousel', value: 'carousel' },
          ]}
          onChange={(v) => builder.setElementData(element.id, { style: v })}
        />
      </div>
      {data.style === 'grid' && (
        <>
          <div className='mb-2 grid grid-cols-2 items-center gap-2'>
            <label className='text-xs'>Image Ratio</label>
            <InputSelect
              defaultValue={data.imageRatio || 'adaptToImage'}
              options={[
                { label: 'Adapt to image', value: 'adaptToImage' },
                { label: 'Portrait', value: 'portrait' },
                { label: 'Square', value: 'square' },
              ]}
              onChange={(v) =>
                builder.setElementData(element.id, {
                  imageRatio: v,
                })
              }
            />
          </div>
          <div className='mb-4 grid grid-cols-2 items-center gap-3'>
            <h4 className='text-xs'>Number of columns on desktop</h4>
            <InputSlider
              value={data.limit || 3}
              max={6}
              onChange={(val) =>
                builder.setElementData(element.id, {
                  limit: val,
                })
              }
            />
          </div>
          <div className='mb-4 grid grid-cols-2 items-center gap-3'>
            <h4 className='text-xs'>Number of columns on mobile</h4>
            <InputSlider
              value={data.limitMobile || 1}
              max={3}
              onChange={(val) =>
                builder.setElementData(element.id, {
                  limitMobile: val,
                })
              }
            />
          </div>
        </>
      )}
      <Separator className='my-4' />
      <h1 className='my-4 text-sm font-bold '>Style</h1>
      <span className=''>Color scheme</span>
      <SchemeSetting
        value={data.colorScheme}
        onChange={(val) =>
          builder.setElementData(element.id, {
            colorScheme: val,
          })
        }
      />
      <PaddingSetting
        value={data.padding}
        onChange={(v) => builder.setElementData(element.id, { padding: v })}
      />
    </div>
  );
}
